import React, { useState } from 'react';
import { useQuery, useMutation } from 'react-query';
import { endpoints, fetcher } from 'services';
import { message } from 'antd';
import { MSG } from 'commons/constants';

const useB2cPmlDetail = (id: number, isClose: (isOk) => void) => {
  /* ======================================================
   * state
   * ====================================================== */
  const [b2cInfo, setB2cInfo] = useState<B2cPmlInfoDto>();

  /* ======================================================
   * hooks
   * ====================================================== */
  const { isLoading } = useQuery(
    [endpoints.b2c.pml.info, id],
    () =>
      fetcher.b2c.postPmlInfo({id: id}),
    {
      onSuccess: (res: B2cPmlInfoResDto) => {
        switch (res.code) {
          case 200:
            setB2cInfo(res.result?.info);
            break;
          case 400:
          default:
            break;
        }
      },
    },
  );

  const { mutate: b2cInsert, isSuccess: insertSuccess } = useMutation(
    [endpoints.b2c.pml.add],
    fetcher.b2c.postPmlInsert,
    {
      onSuccess: (res) => {
        switch (res.code) {
          case 200:
            message.info(MSG.SUCCESS_INSERT, 1);
            break;            
          default:
            message.error(MSG.ERROR_COMMON, 1);
            break;
        }
      },
    },
  )

  const { mutate: b2cUpdate, isSuccess: updateSuccess } = useMutation(
    [endpoints.b2c.pml.update],
    fetcher.b2c.postPmlUpdate,
    {
      onSuccess: (res) => {
        switch (res.code) {
          case 200:
            message.info(MSG.SUCCESS_SAVE, 1);
            break;
          case 500:
            alert(MSG.ERROR_ACCOUNT_CLOSE);
            break;             
          default:
            message.error(MSG.ERROR_COMMON, 1);
            break;
        }
      },
    },
  )  

  const { mutate: b2cDelete, isSuccess: deleteSuccess } = useMutation(
    [endpoints.b2c.delete],
    fetcher.b2c.postProjectDelete,
    {
      onSuccess: (res) => {
        switch (res.code) {
          case 200:
            message.info(MSG.SUCCESS_DELETE, 1);
            break;
          case 500:
            alert(MSG.ERROR_ACCOUNT_CLOSE);
            break;             
          default:
            message.error(MSG.ERROR_COMMON, 1);
            break;
        }
      },
    },
  )
  
  const { mutate: b2cClose, isSuccess: closeSuccess } = useMutation(
    [endpoints.b2c.close],
    fetcher.b2c.postProjectClose,
    {
      onSuccess: (res) => {
        switch (res.code) {
          case 200:
            message.info('상태가 변경 되었습니다.', 1);
            isClose(true);
            /*
            if (!!b2cInfo) {
              setB2cInfo({...b2cInfo, close_yn: b2cInfo.close_yn==='Y'?'N':'Y' });
            }
            */
            break;
          default:
            isClose(false);
            message.error(MSG.ERROR_COMMON, 1);
            break;
        }
      },
    },
  )    

  const { mutate: b2cDrop, isSuccess: dropSuccess } = useMutation(
    [endpoints.b2c.drop],
    fetcher.b2c.postProjectDrop,
    {
      onSuccess: (res) => {
        switch (res.code) {
          case 200:
            message.info("폐강 되었습니다.", 1);
            break;
          case 500:
            alert(MSG.ERROR_ACCOUNT_CLOSE);
            break;              
          default:
            message.error(MSG.ERROR_COMMON, 1);
            break;
        }
      },
    },
  )     

  return { isLoading, b2cInfo, insertSuccess, updateSuccess, deleteSuccess, closeSuccess, dropSuccess, b2cInsert, b2cUpdate, b2cDelete, b2cClose, b2cDrop };
};

export default useB2cPmlDetail;
